export const DEFAULT_LANGUAGE: Language = { value: 'en', alias: 'English', locale: 'en_GB' };
/**
 * Languages supported in Kempower panel.
 */
export const locales = [
    DEFAULT_LANGUAGE,
    { value: 'fi', alias: 'Suomi', locale: 'fi_FI' },
    { value: 'no', alias: 'Norsk', locale: 'no_NO' },
    { value: 'se', alias: 'Svenska', locale: 'sv_SE' },
    { value: 'fr', alias: 'Français', locale: 'fr_FR' },
    /* { value: 'de', alias: 'Deutsch', locale: 'de_DE' },
     { value: 'zh', alias: '中文', locale: 'zh_CN' },
     { value: 'da', alias: 'Dansk', locale: 'da_DK' },
     { value: 'es', alias: 'Español', locale: 'es_ES' },
     { value: 'hu', alias: 'Magyar', locale: 'hu_HU' },
     { value: 'it', alias: 'Italiano', locale: 'it_IT' },
     //{ value: 'ja', alias: '日本語', locale: 'ja_JP' },
     { value: 'nl', alias: 'Nederlands', locale: 'nl_NL' },
     { value: 'pl', alias: 'Polski', locale: 'pl_PL' },
     { value: 'pt', alias: 'Português', locale: 'pt_PT' },
     { value: 'ru', alias: 'Pусский', locale: 'ru_RU' },
    ,
     { value: 'cs', alias: 'Čeština', locale: 'cs_CZ' }*/
];

export interface Language {
    alias: string;
    value: string;
    locale: string;
}
